// extracted by mini-css-extract-plugin
export default {"projects":"Main_projects__VLY7x"};